import React from 'react';
import { CheckCircle2, Users } from 'lucide-react';
export function SocialProof() {
  const checks = ['Funciona con Claude.ai (gratuito y Pro)', 'No necesitás saber programar', 'Resultados desde el primer uso', 'Diseñado para el mercado hispano de infoproductos'];
  return <section className="py-12 px-4 border-y border-white/10 bg-white/5 backdrop-blur-sm" data-id="element-220">
      <div className="max-w-5xl mx-auto" data-id="element-221">
        <div className="flex flex-col items-center text-center mb-8" data-id="element-222">
          <div className="bg-[#00B4D8]/20 p-3 rounded-full mb-4" data-id="element-223">
            <Users className="w-8 h-8 text-[#00B4D8]" data-id="element-224" />
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-white" data-id="element-225">
            +500 emprendedores digitales ya usan inteligencia artificial para
            escalar sus infoproductos
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-226">
          {checks.map((check, index) => <div key={index} className="flex items-start gap-3 bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-227">
              <CheckCircle2 className="w-6 h-6 text-[#27AE60] flex-shrink-0" data-id="element-228" />
              <span className="text-gray-200 font-medium" data-id="element-229">{check}</span>
            </div>)}
        </div>
      </div>
    </section>;
}